import { DropDownListContainer, DropDownList, DropDownContainer, DropDownHeader, ListItem } from '../Viewer/styled/StyledView';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCaretUp, FaCaretDown } from '../../../util/reactIcons';

export const selectButton = ({currentValue, values, callback}) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(t(currentValue));
    const toggling = () => setIsOpen(!isOpen);

    const onOptionClicked = (value) => {
        setSelectedOption(t(values[value]));
        setIsOpen(false);
        callback(value)
      };


    return (
        <DropDownContainer>
        <DropDownHeader onClick={toggling}>
             {selectedOption === t(currentValue) ? selectedOption : t(currentValue)}
             {isOpen ? <FaCaretUp fill="gray" /> : <FaCaretDown fill="gray"/>}
           </DropDownHeader>
         {isOpen && ( 
           <DropDownListContainer>
               <DropDownList>
               {values.map((item, i) => (
                   <ListItem  key={i} onClick={() => onOptionClicked(i)}>
                     {t(item)}
                   </ListItem>
                 ))}
               </DropDownList>
             </DropDownListContainer>
             )
           }
        </DropDownContainer>
    )
}

